module.exports = __webpack_public_path__ + "static/img/head-bg.693be81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/head-bg.png
// module id = 4Dyn
// module chunks = 1